import { render, staticRenderFns } from "./OnboardingCreateTeamForm.vue?vue&type=template&id=ce6950b0&scoped=true&"
import script from "./OnboardingCreateTeamForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingCreateTeamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6950b0",
  null
  
)

export default component.exports